import { type ApiResult, type BaseParams, type FloorpriceHistoryResponse, links, Request } from '@app/client';

import { apiReturnResults } from '../../../../ApiFactory';

function getFloorpriceHistory(params: BaseParams): Promise<ApiResult<FloorpriceHistoryResponse>> {
    const target = links.daas().v2.market.floorprice;
    return Request.getRequest<FloorpriceHistoryResponse>({
        ...params,
        target,
        apiSettingsType: 'daasV2',
    });
}

export function callGetFloorpriceHistory(params: BaseParams & { statsOnly?: boolean }) {
    return apiReturnResults<FloorpriceHistoryResponse>(getFloorpriceHistory, params, true);
}
